import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-terminate-worker',
	templateUrl: './modal-terminate-worker.component.html',
	imports: [
		CommonModule, TranslatePipe, LoaderOverlayComponent, 
		InputDatepickerNewComponent, ItemNotificationComponent, FormsModule
	]
})
export class ModalTerminateWorkerComponent implements OnInit {
	private config: Config = inject(Config);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalTerminateWorkerComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'tw-' + Date.now();
		this.vm.businessUserWorker = this.vm.businessUserWorker;
		this.vm.user = this.session.getSession().user;
		var minDate;
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			minDate = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.getExistingTerminationWarning = this.getExistingTerminationWarning;
		
		if (!this.vm.businessUserWorker.worker.terminationDate) {
			this.vm.businessUserWorker.worker.terminationDate = minDate ? minDate : new Date();
		}
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	getName() {
		return this.vm.businessUserWorker ? this.vm.businessUserWorker.firstName + ' ' + this.vm.businessUserWorker.lastName : '';
	}
	
	submit() {
		this.vm.processing = true;
		var terminationDate: any = this.angularHelperService.copy(this.vm.businessUserWorker.worker.terminationDate);
		this.vm.businessUserWorker.worker.terminationDate = moment(this.vm.businessUserWorker.worker.terminationDate)
			.startOf("day").utcOffset(0, true).toDate();
		this.restService.saveBusinessClientUserDeactivate(this.vm.businessUserWorker.worker)
			.then((response) => {
				this.vm.businessUserWorker.existingTerminationDate = terminationDate;
				if (!response.active) {
					this.vm.businessUserWorker.worker.active = false;
					this.vm.businessUserWorker.processing = false;
				}
				this.dialogRef.close(response);
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
			});
	}
	
	getExistingTerminationWarning() {
		return this.angularFilterHelperService.translate('Business_Client_User.Existing_Deactivation_Date')
			+ ": "
			+ this.angularFilterHelperService.formatDate(this.vm.businessUserWorker.existingTerminationDate, 'dd.MM.yyyy');
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}